const instanceZUID = window.location.host.split(".")[0];
export default instanceZUID;
